__turbopack_context__.v({
  "absLogoHorizon": "AppFooter-module-scss-module__--_9JW__absLogoHorizon",
  "divContainer": "AppFooter-module-scss-module__--_9JW__divContainer",
  "footerContainer": "AppFooter-module-scss-module__--_9JW__footerContainer",
  "frame": "AppFooter-module-scss-module__--_9JW__frame",
  "frame2": "AppFooter-module-scss-module__--_9JW__frame2",
  "frame3": "AppFooter-module-scss-module__--_9JW__frame3",
  "frame4": "AppFooter-module-scss-module__--_9JW__frame4",
  "frame5": "AppFooter-module-scss-module__--_9JW__frame5",
  "frame6": "AppFooter-module-scss-module__--_9JW__frame6",
  "linkWrapper": "AppFooter-module-scss-module__--_9JW__linkWrapper",
  "pContainer": "AppFooter-module-scss-module__--_9JW__pContainer",
  "socialIconsLogo": "AppFooter-module-scss-module__--_9JW__socialIconsLogo",
  "textWrapper": "AppFooter-module-scss-module__--_9JW__textWrapper",
  "textWrapper2": "AppFooter-module-scss-module__--_9JW__textWrapper2",
  "thiLogoFull": "AppFooter-module-scss-module__--_9JW__thiLogoFull",
});
